var hotelLocationPagesEU = {
  'de/flughafenhotel-amsterdam': 'Amsterdam',
  'de/flughafenhotel-basel': 'Basel',
  'de/flughafenhotel-bergamo': 'Bergamo',
  'de/flughafenhotel-bratislava': 'Bratislava',
  'de/flughafenhotel-bruessel': 'Brüssel',
  'de/hotel-charleroi-airport': 'Charleroi',
  'de/flughafenhotel-mailand-malpensa': 'Mailand Malpensa',
  'de/flughafenhotel-rom': 'Rom',
  'de/flughafenhotel-rotterdam': 'Rotterdam',
  'de/flughafenhotel-wien': 'Wien',
  'de/flughafenhotel-zuerich': 'Zürich'
}

module.exports = hotelLocationPagesEU



// WEBPACK FOOTER //
// ./shared/config/hotelLocationPagesEU.js